import './bootstrap';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import flatpickr from "flatpickr";
import { Romanian } from 'flatpickr/dist/l10n/ro.js';